import { Component, ViewChild, ElementRef } from "@angular/core";
import { NavController, Platform, Slides } from "ionic-angular";
import { Geolocation } from "@ionic-native/geolocation";
import { mapStyle } from "./mapStyle";

import * as MarkerClusterer from 'node-js-marker-clusterer';
import { EventsProvider } from "../../providers/events/events.provider";
import { EventPage } from "../event/event";

declare const google;

@Component({
  selector: "page-map",
  templateUrl: "map.html"
})
export class MapPage {
  @ViewChild("map") mapElement: ElementRef;
  @ViewChild('slider') slider: Slides;
  map: any;

  markers = [];
  icons = [];
  marker_active = null;
  //
  // - le Café des jacobins 
  // - la trinquette
  // - Loco loca
  // - Le congrès 
  // - Le mabilais
  // - Monsieur Joe
  //
  
  bars;
  
  // bars = [
  //   {
  //     title: "Meltdown Rennes",
  //     count: 4,
  //     note: 4.5,
  //     global: " · €€ · Bar",
  //     address: "1,5 km · 47 Rue Jean Guéhenno",
  //     status: "Ferme bientôt",
  //     horaires: " ⋅ 01:00",
  //     infos: "Argent liquide seulement · Jeux de café",
  //     picture:
  //       "https://firebasestorage.googleapis.com/v0/b/drinkin-17205.appspot.com/o/bars%2Fmetdown.png?alt=media&token=f3967f98-128e-4b2a-9f96-a0c693713e61"
  //   },
  //   {
  //     title: "O'Connell's Irish Pub",
  //     count: 2,
  //     note: 2.5,
  //     global: " · €€ · Bar",
  //     address: "2.2 km · 7 Place du Parlement de Bretagne, 35000 Rennes",
  //     status: "Ferme bientôt",
  //     horaires: " ⋅ 02:00",
  //     infos:
  //       "Carte typique, concerts live, matchs de rugby, happy hour et jeu de fléchettes pour ce pub irlandais animé.",
  //     picture:
  //       "https://firebasestorage.googleapis.com/v0/b/drinkin-17205.appspot.com/o/bars%2Foconnells.png?alt=media&token=0caa0d5b-ac7a-41b0-9d58-bb839d0a8f99"
  //   }
  // ];

  constructor(
    public navCtrl: NavController,
    public geolocation: Geolocation,
    public eventsProvider: EventsProvider,
    public platform: Platform
  ) {}

  ionViewDidLoad() {
    console.log("----------- load map -------------")
    this.loadMap();
    this.getPosition();
    this.refresh();
  }
  async refresh(){

    this.bars = await this.eventsProvider.getEvents();
    this.addBars();
    console.log("this.bars",this.bars);
  }
  getPosition() {
    console.log("getPosition");
    this.geolocation
      .getCurrentPosition()
      .then(resp => {
        // resp.coords.latitude
        // resp.coords.longitude
        // let latLng = new LatLng(resp.coords.latitude, resp.coords.longitude);
        console.log("setZoom + panTo");
        this.map.setZoom(15);
        this.map.panTo({lat: resp.coords.latitude, lng:resp.coords.longitude});

        let icon_circle = {
          url: 'assets/markers/location.png',
          scaledSize: new google.maps.Size(40, 40),
          anchor: new google.maps.Point(20, 20),
        };

        new google.maps.Marker({
          position:{lat: resp.coords.latitude, lng:resp.coords.longitude},
          map: this.map,
          icon:icon_circle
        });
      })
      .catch(error => {
        console.log("Error getting location", error);
    });

    let watch = this.geolocation.watchPosition();
    watch.subscribe(data => {
      console.log("watchPosition data", data);

      // let pos = {
      //   lat: data.coords.latitude,
      //   lng: data.coords.longitude
      // };
      // let marker = new google.maps.Marker({
      //   position: pos,
      //   map: this.map
      // });
      // this.map.setCenter(pos);
    });
  }

  loadMap() {
    let myLocation = {lat:48.128868399999995,lng:-1.6626363};
    let style = [];
    style = mapStyle;
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      controls: {
        myLocationButton: true,
        indoorPicker: true,
        zoom: true,
        disableDefaultUI: true,
      },
      disableDefaultUI: true,
      MyLocationEnabled: true,
      setMyLocationButtonEnabled: true,
      compass: true,
      zoom: 4,
      center:  {lat: 48.862, lng: 2.35},
      mapTypeId: "roadmap",
      styles: style
    });
  }

  goToBar(bar){
    this.navCtrl.push(EventPage, {event:bar});
  }

  addBars(){
    this.bars.map((bar, i) => {
      this.generateIcon(bar,i);
      let marker = new google.maps.Marker({
        position: {lat: parseFloat(bar.address.lat), lng: parseFloat(bar.address.lon)},
        id:i,
        optimized:false,
        map:this.map,
        icon:this.icons[i]['classic']
      });

      google.maps.event.addDomListener(marker, 'click', () => {
          console.log("marker click",marker.id);
          console.log("marker marker_active",this.marker_active);
            // 
            // console.log("marker",marker);
            // console.log("marker.icon",marker.icon);
            // console.log("marker.icon.src",marker.icon.url);
          
            // console.log(document.querySelectorAll('img[src="'+marker.icon.url+'"]'));

          this.slider.slideTo(i);
      });
      this.markers.push(marker);
      return;
    });
    console.log("this.markers", this.markers);

    let options = {
      cssClass: 'custom-pin'
    };
    // Add a marker clusterer to manage the markers.
    // new MarkerClusterer(this.map, this.markers,{imagePath: 'assets/markers/m'},options);
  
    var myoverlay = new google.maps.OverlayView();
    myoverlay.draw = function () {
      // console.log(this.getPanes());
        this.getPanes().markerLayer.id='markerLayer';
    }
    myoverlay.setMap(this.map);

  }
  setActiveCard(index){
    console.log("index",index);
    console.log("bar",this.bars[index]);
    if(this.marker_active != null && this.marker_active != index){
      this.markers[this.marker_active].setIcon(this.icons[this.marker_active]['classic']);
    }
    if(this.icons[index] && this.markers[index]){
      this.markers[index].setIcon(this.icons[index]['active']);
      this.marker_active = this.markers[index].id;
      // this.map.setZoom(13);
      this.map.panTo({lat: parseFloat(this.bars[index].address.lat), lng:parseFloat(this.bars[index].address.lon)});
    }
  }


  // On slide changed
  slideChanged() {
    let currentIndex = this.slider.getActiveIndex();
    this.setActiveCard(currentIndex);

  }

  generateIcon(bar,i){

    // let icon = {
    //   url: 'assets/markers/metldown_marker_orange.png',
    //   scaledSize: new google.maps.Size(40, 40),
    //   anchor: new google.maps.Point(20, 20),
    // };
    let icon = {
      url: 'data:image/svg+xml;utf-8, \
      <svg width="40" height="40" viewBox="0 0 40 40"  xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"> \
        <image width="40" height="40" xlink:href="' + bar.picture + '"/> \
        <circle cx="20" cy="20" r="20" stroke="orange" stroke-width="4" fill="transparent" /> \
      </svg>',
      scaledSize: new google.maps.Size(40, 40),
      anchor: new google.maps.Point(20, 20),
    };
    let icon_white = {
      url: 'data:image/svg+xml;utf-8, \
      <svg width="40" height="40" viewBox="0 0 40 40"  xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"> \
        <image width="40" height="40" xlink:href="' + bar.picture + '"/> \
        <circle cx="20" cy="20" r="20" stroke="white" stroke-width="4" fill="transparent" /> \
      </svg>',
      scaledSize: new google.maps.Size(40, 40),
      anchor: new google.maps.Point(20, 20),
    };

    this.icons[i] = {};
    this.icons[i]["classic"] = icon;
    this.icons[i]["active"] = icon_white;
  }
}



// WEBPACK FOOTER //
// ./src/pages/map/map.ts